module.exports = __webpack_public_path__ + "static/media/road-glide-special-bright-chrome.2bf83a4a.png";